(function () {
    /* ==============================
     * CONFIG
     * ============================== */

    const BUPA_DOMAINS = leaverSurveyConfig.allowedDomains;

    const SURVEY_SESSION_KEY = 'leaverSurveyCompleted';

    const overlay = document.getElementById('leaver-survey-overlay');
    const modal = overlay.querySelector('.leaver-modal');
    const closeBtn = overlay.querySelector('.leaver-close');
    const leaveBtn = document.getElementById('leaver-leave');
    const surveyBtn = document.getElementById('leaver-start-survey');

    let pendingNavigationUrl = null;
    let lastFocusedElement = null;

    let lastClickTime = 0;

    // ✅ FLAGS
    let closedViaKeyboard = false;
    let navigatedViaModal = false;

    /* ==============================
     * UTILITIES
     * ============================== */

    function normalizeHostname(url) {
        try {
            return new URL(url).hostname.toLowerCase();
        } catch {
            return '';
        }
    }

    function isSameDomain(url) {
        return normalizeHostname(url) === normalizeHostname(location.href);
    }

    function isBupaDomain(url) {
        const host = normalizeHostname(url);

        return BUPA_DOMAINS.some(domain => {
            const d = domain.toLowerCase();

            // ✅ Handle both www and non-www equivalence
            if (d.startsWith('www.')) {
                const base = d.slice(4);
                return host === d || host === base;
            }

            return host === d || host === 'www.' + d;
        });
    }

    function isJavascriptUrl(href) {
        return typeof href === 'string' &&
            href.trim().toLowerCase().startsWith('javascript:');
    }

    function getLinkElement(el) {
        while (el && el !== document) {
            if (el.tagName && el.tagName.toLowerCase() === 'a' && el.href) {
                return el;
            }
            el = el.parentNode;
        }
        return null;
    }

    function getFocusableElements() {
        return modal.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), ' +
            'textarea:not([disabled]), select:not([disabled]), ' +
            '[tabindex]:not([tabindex="-1"])'
        );
    }

    function trapFocus(event) {
        if (event.key !== 'Tab') return;

        const focusable = getFocusableElements();
        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (!modal.contains(document.activeElement)) {
            event.preventDefault();
            first.focus();
            return;
        }

        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }

    /* ==============================
     * SAFE FOCUS HANDLING
     * ============================== */

    function placeTemporaryFocusAnchor(element) {
        if (!element || !element.parentNode) return;

        const anchor = document.createElement('span');
        anchor.setAttribute('tabindex', '-1');

        // ✅ IMPORTANT: place AFTER element so TAB goes forward
        element.parentNode.insertBefore(anchor, element.nextSibling);

        anchor.focus({ preventScroll: true });

        setTimeout(() => {
            anchor.remove();
        }, 0);
    }

    /* ==============================
     * BACKGROUND INERT
     * ============================== */

    function toggleInert(element, inertOn) {
        if (inertOn) {
            element.setAttribute('aria-hidden', 'true');

            if ('inert' in element) {
                element.inert = true;
            } else {
                element.style.pointerEvents = 'none';
            }
        } else {
            element.removeAttribute('aria-hidden');

            if ('inert' in element) {
                element.inert = false;
            } else {
                element.style.pointerEvents = '';
            }
        }
    }

    function setBackgroundInert(active) {
        const header = document.querySelector('header');
        const footer = document.querySelector('footer');
        const mainContainer = document.getElementById('mobile-main-content');

        if (header) toggleInert(header, active);
        if (footer) toggleInert(footer, active);

        if (mainContainer) {
            Array.from(mainContainer.children).forEach(child => {
                if (child.id === 'leaver-survey-overlay') return;
                toggleInert(child, active);
            });
        }
    }

    /* ==============================
     * MODAL CONTROL
     * ============================== */

    function openModal(url) {
        lastFocusedElement = document.activeElement;
        pendingNavigationUrl = url;

        overlay.classList.add('is-visible');
        overlay.setAttribute('aria-hidden', 'false');
        document.body.classList.add('leaver-modal-open');

        document.body.style.overflow = 'hidden';

        setBackgroundInert(true);

        requestAnimationFrame(() => {
            modal.focus();
        });

        $('.leaver-primary, .leaver-secondary')
            .filter(function () {
                return $(this).text().trim() === '';
            })
            .remove();

    }

    function closeModal() {
        overlay.classList.remove('is-visible');
        overlay.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('leaver-modal-open');

        setBackgroundInert(false);
        pendingNavigationUrl = null;

        lastClickTime = 0;

        document.body.style.overflow = '';

        if (!navigatedViaModal) {
            setTimeout(() => {

                if (closedViaKeyboard) {
                    if (lastFocusedElement && document.body.contains(lastFocusedElement)) {

                        lastFocusedElement.focus({ preventScroll: true });
                    }
                } else {
                    // ✅ Mouse close → continue TAB flow
                    if (lastFocusedElement && document.body.contains(lastFocusedElement)) {
                        placeTemporaryFocusAnchor(lastFocusedElement);
                    }
                }

                closedViaKeyboard = false;

            }, 0);
        }
    }

    function continueNavigation() {
        if (pendingNavigationUrl) {
            navigatedViaModal = true;
            window.location.href = pendingNavigationUrl;
        }
    }

    /* ==============================
     * LINK INTERCEPT
     * ============================== */

    function handleLinkClick(e) {
        const now = Date.now();

        if (now - lastClickTime < 400) return;
        lastClickTime = now;

        const link = getLinkElement(e.target);
        if (!link) return;

        const href = link.getAttribute('href');
        if (!href) return;

        if (
            isJavascriptUrl(href) ||
            href.startsWith('#') ||
            href.startsWith('mailto:') ||
            href.startsWith('tel:')
        ) return;

        if (sessionStorage.getItem(SURVEY_SESSION_KEY) === 'true') return;

        const targetUrl = link.href;

        if (isSameDomain(targetUrl) || isBupaDomain(targetUrl)) return;

        e.preventDefault();
        openModal(targetUrl);
    }

    document.addEventListener('click', handleLinkClick);

    /* ==============================
     * BUTTON ACTIONS
     * ============================== */

    closeBtn.addEventListener('click', function (e) {

        // ✅ Detect if triggered via keyboard (Enter/Space)
        const isKeyboardClick = e.detail === 0;

        closedViaKeyboard = isKeyboardClick;

        closeModal();
    });
    leaveBtn.addEventListener('click', continueNavigation);

    surveyBtn.addEventListener('click', function (e) {
        e.preventDefault();

        $.ajax({
            url: '/LeaverSurvey/IncrementSurveyCount',
            type: 'POST',
            success: function (result) {
                if (result?.success) {
                    sessionStorage.setItem(SURVEY_SESSION_KEY, 'true');
                    window.location.href = leaverSurveyConfig.surveyUrl;
                }
            }
        });
    });

    /* ==============================
     * KEYBOARD HANDLING
     * ============================== */

    document.addEventListener('keydown', function (e) {
        if (!overlay.classList.contains('is-visible')) return;

        if (e.key === 'Escape') {
            closedViaKeyboard = true;
            closeModal();
        } else {
            trapFocus(e);
        }
    });

    /* ==============================
     * NAVIGATION HANDLING
     * ============================== */

    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'auto';
    }

    window.addEventListener('pageshow', function (e) {
        navigatedViaModal = false;

        if (e.persisted) {
            closeModal();
        }
    });

})();